

























































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import CModal from "@/basics/modal/CModal.vue";
import ModalTitle from "@/basics/modal/ModalTitle.vue";
import NoData from "@/basics/boxes/NoData.vue";
import { USER_ME, UserData } from "@/graphql/query/user/me";
import { ROOM_ONE, RoomVariables, RoomData } from "@/graphql/query/room/one";
import { check, Scopes } from "@/lib/scope";

@Component({
  components: {
    CButton,
    NoteBox,
    CModal,
    ModalTitle,
    NoData
  },
  apollo: {
    me: USER_ME,
    room: {
      query: ROOM_ONE,
      variables(): RoomVariables {
        return { roomId: this.$apollo.vm.$route.params.roomId };
      }
    }
  }
})
export default class RemoteOperation extends Vue {
  me: UserData | null = null;
  room: RoomData | null = null;
  remote = false;
  remoteOpenCheckModal = false;

  get rescueNotAllowed(): boolean {
    const allowed: Scopes<"Group"> = [
      {
        resource: "Group",
        resourceId: this.$route.params.roomGroupId as string,
        action: "rescue_operation"
      }
    ];
    return !check(allowed, this.me!.scopes);
  }

  orehamajidaze() {
    this.remoteOpenCheckModal = false;
    this.$router.push({ name: "room-remote-open" });
  }
}
